export default {
  user: {
    info: 'Страница пользователя изменилась!',
    text: 'В профиле вы можете видеть всю информацию о вас и проверить, как она отражается у других пользовтаелей',
    look: 'Обратите внимание: редактирвоание коллекций, работ и событий',
    move: 'перемещено сюда',
    thanks: 'Понятно, спасибо',
  },
};
